import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Returns [askPassword(), dialogElement]. askPassword resolves with the typed password or null.
export const useAdminPassword = () => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const resolver = useRef(null);

  const ask = () =>
    new Promise((resolve) => {
      resolver.current = resolve;
      setValue("");
      setOpen(true);
    });

  const finish = (v) => {
    setOpen(false);
    resolver.current?.(v);
    resolver.current = null;
  };

  const dialog = (
    <Dialog open={open} onOpenChange={(o) => !o && finish(null)}>
      <DialogContent data-testid="admin-unlock-dialog" className="rounded-none max-w-sm bg-[#FBF9F5]">
        <DialogTitle className="font-display text-2xl">Unlock admin mode</DialogTitle>
        <DialogDescription className="text-sm text-[#71717A]">Enter the admin password you use in the Lamka Online app.</DialogDescription>
        <form onSubmit={(e) => { e.preventDefault(); finish(value); }} className="space-y-4 mt-2">
          <input data-testid="admin-unlock-input" type="password" autoFocus value={value} onChange={(e) => setValue(e.target.value)} className="w-full bg-white border border-[#0F0F0F]/20 focus:border-[#C5A059] outline-none px-3 py-2.5 text-sm" />
          <button data-testid="admin-unlock-submit" type="submit" disabled={!value} className="w-full bg-[#0F0F0F] text-[#C5A059] py-3 text-xs tracking-[0.3em] uppercase disabled:opacity-40">Unlock</button>
        </form>
      </DialogContent>
    </Dialog>
  );
  return [ask, dialog];
};
